    $("body").addClass('custom-template');
    
    $("#to-top").click(function() {
      $("html, body").animate({
        scrollTop: 0
      }, 700);
    });
    $("nav .navbar-nav .nav-link:not(.a-link), #toDown, .get-it").on("click", function(t) {
      if ("" !== this.hashUrl) {
        t.preventDefault();
        var o = this.hash;
        $("html, body").animate({
          scrollTop: $(o).offset().top - 50
        }, 700, function() {
          window.location.hashUrl = o;
        });
      }
    });
    $(window).scroll(function () {
      var t = $(window).scrollTop();
      t >= 501 && $(".navbar").addClass("fixed-top"), t <= 500 && $(".navbar").removeClass("fixed-top");
    });

    // add/minus FEATURE
    

    const purchaseContainers = document.querySelectorAll('.proceed-checkout');
    const product_variant_ID = $('.product-quantity').attr('data-product-id')
    purchaseContainers.forEach(container => {
      const quantityField = container.querySelector('.product-quantity');
      const minusButton = container.querySelector('.price-minus');
      const addButton = container.querySelector('.price-add');
      const addToCartLink = container.querySelector('.addToCart');

      minusButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (quantityField.value > 1) {
          quantityField.value--;
        }
        updateHref(quantityField.value, addToCartLink);
      });

      addButton.addEventListener('click', (e) => {
        e.preventDefault();
        quantityField.value++;
        updateHref(quantityField.value, addToCartLink);
      });

      quantityField.addEventListener('change', () => {
        if (quantityField.value < 1) {
          quantityField.value = 1;
        }
        updateHref(quantityField.value, addToCartLink);
      });

      function updateHref(quantity, link) { 
        const hrefValue = '/cart/' + product_variant_ID + ':' + quantity;
        link.href = hrefValue;
      }
    });
